'use strict';

$(document).ready(function () {
    require('./thirdParty/duets').init();
});
